import { HeadCell } from "./interfaces";

export const headCells: readonly HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Contact",
  },
  {
    id: "phone",
    numeric: false,
    disablePadding: false,
    label: "Call Time",
  },
];
